import { Palette, ShieldCheck, Share2, Inbox } from "lucide-react";
import { Reveal } from "./Reveal";

const steps = [
  {
    num: "01",
    icon: Palette,
    title: "Personalizá",
    desc: "Elegí la portada, las secciones, la galería, la música y el itinerario con vista previa móvil y de escritorio.",
  },
  {
    num: "02",
    icon: ShieldCheck,
    title: "Configurá el acceso",
    desc: "Definí si tu invitación es pública, privada o mixta, y cargá tu lista de invitados con pases y mesas.",
  },
  {
    num: "03",
    icon: Share2,
    title: "Compartí",
    desc: "Un mismo enlace para todos. Además, mensajes individuales preparados para enviar por WhatsApp.",
  },
  {
    num: "04",
    icon: Inbox,
    title: "Gestioná las respuestas",
    desc: "Mirá quién confirmó, quién falta y cómo quedaron las mesas, todo desde tu panel.",
  },
];

export const HowItWorks = () => (
  <section id="como-funciona" data-testid="how-it-works-section" className="bg-white py-20 sm:py-28">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <Reveal>
        <p className="text-xs font-semibold uppercase tracking-[0.25em] text-indigo-600">Cómo funciona</p>
        <h2
          className="mt-3 max-w-2xl text-3xl font-medium tracking-tight text-slate-900 sm:text-4xl"
          style={{ fontFamily: "'Outfit', sans-serif" }}
        >
          De la idea a las confirmaciones en cuatro pasos
        </h2>
      </Reveal>

      <div className="mt-14 grid gap-0 sm:grid-cols-2 lg:grid-cols-4">
        {steps.map((s, i) => (
          <Reveal key={s.num} delay={i * 0.1}>
            <div
              data-testid={`step-${s.num}`}
              className="group relative border-t border-slate-200 px-2 py-8 sm:px-6 lg:border-l lg:border-t-0 lg:first:border-l-0"
            >
              <span
                className="text-5xl font-light text-indigo-100 transition-colors duration-300 group-hover:text-indigo-300"
                style={{ fontFamily: "'Outfit', sans-serif" }}
              >
                {s.num}
              </span>
              <div className="mt-5 flex h-11 w-11 items-center justify-center rounded-2xl bg-indigo-50 text-indigo-600 transition-colors duration-300 group-hover:bg-[#4F5BD5] group-hover:text-white">
                <s.icon className="h-5 w-5" />
              </div>
              <h3 className="mt-5 text-lg font-medium text-slate-900" style={{ fontFamily: "'Outfit', sans-serif" }}>
                {s.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-slate-600">{s.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
